<!-- Announcements Table -->
<mat-table [dataSource]="tableData" 
    matSort 
    matSortDisableClear
    matSortActive="StartDate" 
    matSortDirection="desc"
    multiTemplateDataRows>

    <!-- More Column -->
    <ng-container matColumnDef='more'>
        <mat-header-cell *matHeaderCellDef translate> More </mat-header-cell>
        <mat-cell *matCellDef="let announcement; let i = index">
            <span class="material-icons" [ngClass]="{
                'detail-row-expanded-icon': tableData.checkExpanded(announcement),
                'detail-row-collapsed-icon': !tableData.checkExpanded(announcement)
            }"></span>
        </mat-cell>
    </ng-container>

	<!-- New Column -->
	<ng-container matColumnDef='new'>
		<mat-header-cell *matHeaderCellDef translate></mat-header-cell>
		<mat-cell *matCellDef="let announcement; let i = index">
            <span *ngIf="announcement.IsNewAnnouncement"
				translate>
				<b>New</b>
			</span>
		</mat-cell>
	</ng-container>

	<!-- Course Column -->
	<ng-container matColumnDef='course'>
		<mat-header-cell *matHeaderCellDef
			mat-sort-header="Course"
			translate>
			Course
		</mat-header-cell>
		<mat-cell *matCellDef="let announcement; let i = index" translate>
			<span class="truncate"
				translate>
				{{announcement.Course}}
			</span>
		</mat-cell>
	</ng-container>

	<!-- Teacher Column -->
	<ng-container matColumnDef='teacher'>
		<mat-header-cell *matHeaderCellDef
			mat-sort-header="Teacher"
			translate>
			Teacher
		</mat-header-cell>
		<mat-cell *matCellDef="let announcement; let i = index" translate>
			<span class="truncate"
				translate>
				{{announcement.Teacher}}
			</span>
		</mat-cell>
	</ng-container>

    <!-- Announcement Column -->
    <ng-container matColumnDef='announcement'>
        <mat-header-cell *matHeaderCellDef 
            mat-sort-header="StartDate">
            <span translate>Announcements</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let announcement; let i = index" translate>
			<span class="truncate" *ngIf="V10">
            	{{announcement.StartDate | date:'MM/dd/yy'}} - {{announcement.Title}}
			</span>
			<span class="truncate" *ngIf="!V10">
				<span style="background: #FFEB3B;" *ngIf="announcement.IsNewAnnouncement == true" translate>NEW</span>&nbsp;
				{{announcement.StartDate | date:'MM/dd/yy'}} - {{announcement.Title}}
			</span>
        </mat-cell>
    </ng-container>

	<!-- Attachments Column -->
	<ng-container matColumnDef='attachments'>
		<mat-header-cell *matHeaderCellDef
			translate>
			<img alt="Paperclip"
				src="./assets/images/paperclip.png"
				style="height:20px;" />
		</mat-header-cell>
		<mat-cell *matCellDef="let announcement; let i = index" translate>
			{{announcement.AnnouncementAttachments && announcement.AnnouncementAttachments.length > 0 ? 'Y' : ''}}
		</mat-cell>
	</ng-container>
    
    <!-- Expand Row -->
    <ng-container matColumnDef='expandedRow'>
        <td mat-cell 
            class="mat-detail-card"
            *matCellDef="let announcement" 
            (click)="selectedRow = announcement"
            [attr.colspan]="columnsToDisplay.length">

			<!-- Description -->
            <tyl-quill-text-only [attr.aria-label]="'announcement ' + announcement.Title + ' details: ' + stripHTML(announcement.Description)"
                [padding]="0"
                [html]="announcement.Description | translate"
                ExternalLink></tyl-quill-text-only>

			<!-- Attachments -->
			<div *ngIf="announcement.AnnouncementAttachments && announcement.AnnouncementAttachments.length > 0"
				style="display: flex; flex-direction: column; width: 100%;">
				<div *ngFor="let attachment of announcement.AnnouncementAttachments"
					style="display: flex; flex-direction: row; width: 100%;">
					<a style="flex: 1 0 100px; cursor: pointer;"
						(click)="showAttachment(attachment)">
						{{attachment.AttachmentFileName}}
					</a>
					<span style="flex: 3 0 100px">
						{{attachment.AttachmentDescription}}
					</span>
				</div>
			</div>
        </td>
    </ng-container>

    <!-- Row definitions -->
    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay;"
        matRipple 
        tabindex="0" 
        style="cursor: pointer"
        [ngStyle]="{'background-color': selectedRow == row ? 'whitesmoke' : ''}"
        [ngClass]="{'detailRowOpened': tableData.checkExpanded(row)}"
        [attr.aria-label]="'announcement ' + row.Title + ' from ' + (row.StartDate | date:'MM/dd/yy') + '. Press enter to see details.'"
        (click)="tableData.toggleExpanded(row); selectedRow = row;"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedRow']" 
        (click)="selectedRow = row;"
        class="mat-detail-row"
        [ngClass]="{'selectedRow': selectedRow == row}"
        [@detailExpand]="tableData.checkExpanded(row) ? 'expanded' : 'collapsed'"
        style="overflow: hidden"></mat-row>
</mat-table>
